module.exports = __webpack_public_path__ + "img/frais.7ae0abe0.png";